import React from 'react';
import { useNavigate } from 'react-router-dom';

const useFetch = () => {
  const [data, setData] = React.useState(null);
  const [error, setError] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();

  const request = React.useCallback(async (url, options) => {
    let response;
    let json;
    try {
      setError(null);
      setLoading(true);
      response = await fetch(url, options);
      json = await response.json();
      //console.log(response);
      //console.log(json);
      //if (response.ok === false) throw new Error(json.message);
      if (!response.status == 200) throw new Error({'message' : 'Faça o login para continuar'});
    } catch (err) {
      json = null;
        if (err.message == 'Token has expired') {
          setError('Você precisa se logar novamente.');
          //setTimeout(userLogout(), 5000);
          //navigate('/login');
        } else {
          setError(err.message);          
        }
    } finally {
      setData(json);
      setLoading(false);
      return { response, json };
    }
  }, []);

  return {
    data,
    loading,
    error,
    request,
  };
};

export default useFetch;
